import { filter, groupBy, includes, isEmpty, map, values } from 'lodash';
import React, { useMemo } from 'react';
import useAssetConditionsSelector from '../../../data/hooks/useAssetConditionsSelector';
import SpinnerError from '../../utils/SpinnerError';
import MultiselectFilter from './MultiselectFilter';
import useT from '../../utils/Translations/useT';
const AssetConditionsSelector = ({ availableOptions, isDisabled, filter: filterProps, ...props }) => {
    const t = useT();
    const { assetConditions, error, loading } = useAssetConditionsSelector();
    const _assetConditions = useMemo(() => availableOptions && !isEmpty(availableOptions)
        ? filter(assetConditions, ({ id }) => includes(availableOptions, id))
        : assetConditions, [availableOptions, assetConditions]);
    const options = useMemo(() => [
        [{ id: null, name: t('No Condition') }],
        ...values(groupBy(map(_assetConditions, condition => ({
            ...condition,
            name: t(condition.name),
        })), 'grouping')),
    ], [_assetConditions, t]);
    const disabled = useMemo(() => (isDisabled ? isDisabled(filterProps) : false), [isDisabled, filterProps]);
    return (<SpinnerError error={error} loading={loading}>
      <MultiselectFilter disabled={disabled} options={options} title={t('Asset condition')} {...props}/>
    </SpinnerError>);
};
export default AssetConditionsSelector;
